import { getDataSecurityAppUsers } from '@api/data-security';

import { createGetAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const getCoreDataSecurityAppUsersSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityAppUsers',
	receive: true,
	request: true,
	requestHandler: getDataSecurityAppUsers,
	retainDataOnRequest: true,
	yieldType: SagaYieldType.Leading
});
